<template>
  <div>
    <div class="container mt-5">
      <div class="row">
        <div class="col-12 text-center">
          <p class="fs-1 naranjaFit roboto">LO QUE OPINAN</p>
          <p class="quicksand fs-4 colorLetras">DE NOSOTROS</p>
        </div>
      </div>
      <div class="row mb-5" id="imgFotos"></div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  created() {
    let baseUrl = process.env.VUE_APP_API_URL || "https://thefitgym.dyndns.org:3000/pagina_services/fitbar";
    if (typeof window !== "undefined" && window.location && window.location.hostname) {
      const currentHost = window.location.hostname;
      baseUrl = baseUrl.replace("localhost", currentHost).replace("127.0.0.1", currentHost);
    }
    var urlFotos = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/';
    axios({
      method: "get",
      url: `${baseUrl}/getOpiniones.php`,
      responseType: "json",
    }).then(function (response) {
      var imgOpinion = document.getElementById("imgFotos");
      for (const iterator of response.data) {
        imgOpinion.innerHTML += `<div class="col-md-4 col-lg-4 col-xl-4"><img class="img-fluid ms-1" src="${
          urlFotos + iterator.foto
        }"/></div>`;
      }
    });
  },
};
</script>
<style></style>
